import { action } from 'satcheljs';

import type { AccountSource } from '../store/schema/AccountSourceList';

export default action('ON_COPRINCIPAL_ACCOUNT_ADDED', (addedAccount: AccountSource) => ({
    addedAccount,
}));
